var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 1.5,
    width: 18,
    height: 2.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 1,
    y: 7.50012,
    width: 18,
    height: 2.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 1,
    y: 13.4998,
    width: 18,
    height: 2.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClosed);
export default __webpack_public_path__ + "static/media/menu-closed.f23dfa2a430c5065b1218ebde633dab3.svg";
export { ForwardRef as ReactComponent };